import "features/excelDiff/pages/ExcelDiffPage.css";
import {DataLoadingStatus} from "shared/types/common";
import React from "react";
import {PVRDocType} from "../types";
import {SelectCategoryInput, SelectOptionsPanel} from "shared/components/inputFields";
import PVRTable from "../components/PVRTable";
import {usePVR} from "../hooks/usePVR";

const PVRPage = () => {
    const {
        catNum, setCatNum,
        status, rows,
        availableDocTypes, selectedDocTypeIdx, setSelectedDocTypeIdx,
        submit,
    } = usePVR();

    return (
        <div className="excel-diff-page">
            <div className="inputs-panel">
                <div className="inputs-container">
                    <SelectCategoryInput label="Category Number:" value={catNum} valueSetter={setCatNum} lowerLimit={1} upperLimit={9999} preprocessValue={(v) => v ? parseInt(v) : v} allowNegative={false} allowFraction={false}/>
                </div>
                <div className="button-container">
                    <button className="button green-button" disabled={catNum < 1 || catNum > 9999 || status === DataLoadingStatus.Loading}
                            onClick={submit}>Load PVR
                    </button>
                </div>
            </div>
            {rows !== undefined && availableDocTypes.length > 1? <SelectOptionsPanel options={availableDocTypes.map(doc => `${doc[0]} (${doc[1]})`)} selectedIdx={selectedDocTypeIdx} setSelectedIdx={setSelectedDocTypeIdx}/> : <></>}

            <div className="table-container scrollable" style={{marginTop: 15}}>
                {status === DataLoadingStatus.Loading? <p className="info-text">It may take up to 5 minutes. Please, be patient and don't refresh the page!</p> : <></>}
                {status === DataLoadingStatus.Error? <p className="error-text">Network error occured! Please, reload the page and try again...</p> : <></>}

                {rows !== undefined && rows.length > 0? <PVRTable result={rows} selectedDoc={availableDocTypes[selectedDocTypeIdx][0] as PVRDocType}/> : <></>}
            </div>
        </div>
    );
}

export default PVRPage;